// Application version configuration
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
export const APP_NAME = 'Sede virtual C.A. Pacífico';

// Function to get complete version information
export const getVersionInfo = () => {
  return {
    version: APP_VERSION,
    name: APP_NAME,
    fullVersion: `v${APP_VERSION}`,
    buildTime: process.env.REACT_APP_BUILD_TIME || new Date().toISOString()
  };
}; 